import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import * as ko from "knockout";
import {Application} from "../application";

export class RemoveEstimateCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.RemoveEstimate;
    
    canExecute = ko.computed(() => {
        return true;
    });
    
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    
    execute(id: number): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        let dfd = $.Deferred();
        
        let estimate = this.app.state.estimate();
       
        
        this.app.apiManager.estimate.deleteEstimate({id: id}).then(() => {
           
            if(estimate && estimate.id() == id) {
                this.app.state.estimate(undefined);
            }
            
            dfd.resolve();
        });
        
        return dfd.promise();
    }

    name = "Delete estimate";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/removeEstimateCommand.ts